import { provideTranslocoScope } from "@jsverse/transloco";
import { JsonObject } from "@tenzu/repository/base/misc.model";
import { PLUGINS_TOKEN } from "../../app/app.config";
import PortalService from "./portal.service";
import * as z from "zod/v4";
import { ConfigSchema, ConfigSchemaService } from "@tenzu/repository/config-app/config.model";
import { Service } from "@angular/core";

export const ConfigSchemaPortail = ConfigSchema.extend({
  portal: z.boolean().default(false),
});
export type ConfigModelPortal = z.infer<typeof ConfigSchemaPortail>;

@Service()
export class ConfigSchemaPortailService extends ConfigSchemaService {
  override schema() {
    return ConfigSchemaPortail;
  }
}

export const loader = ["en-us", "es-es", "fr-fr"].reduce(
  (acc: Record<string, () => Promise<JsonObject>>, lang: string) => {
    acc[lang] = () => import(`./i18n/${lang}.json`) as Promise<JsonObject>;
    return acc;
  },
  {},
);
export const providerPortalTransloco = provideTranslocoScope({
  scope: "portal",
  loader,
});

export const providePortalPluginToken = () => [
  {
    provide: PLUGINS_TOKEN,
    useClass: PortalService,
    multi: true,
  },
  { provide: ConfigSchemaService, useClass: ConfigSchemaPortailService },
];
